import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { IUser, IUserRequest, IDeleteResponse } from '../interfaces/user.interface';

import { IApiResponse } from '../../../shared/interfaces/apiResponse.interface';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly http = inject(HttpClient);

  private readonly apiUrl = environment.apiUrl;

  getUsers(pageNumber?: number, pageSize?: number, search?: string, countryId?: number) {
    const params: Record<string, string> = {};

    if (pageNumber !== undefined) {
      params['pageNumber'] = pageNumber.toString();
    }

    if (pageSize !== undefined) {
      params['pageSize'] = pageSize.toString();
    }

    if (search?.trim()) {
      params['search'] = search;
    }

    if (countryId !== undefined && countryId !== null) {
      params['countryId'] = countryId.toString();
    }

    return this.http.get<IApiResponse<IUser[]>>(`${this.apiUrl}/users`, {
      params,
    });
  }

  getUserById(id: number): Observable<IApiResponse<IUser>> {
    return this.http.get<IApiResponse<IUser>>(`${this.apiUrl}/users/${id}`);
  }

  getUserByEmail(email: string): Observable<IApiResponse<IUser>> {
    return this.http.post<IApiResponse<IUser>>(`${this.apiUrl}/users/email`, { email });
  }

  getHeadDevTeam(headDevId: number) {
    return this.http.get<IApiResponse<IUser[]>>(
      `${this.apiUrl}/users/headDevelopment/team/${headDevId}`,
    );
  }

  createUser(user: IUserRequest): Observable<IApiResponse<IUser>> {
    return this.http.post<IApiResponse<IUser>>(`${this.apiUrl}/users`, user);
  }

  updateUser(user: IUserRequest): Observable<IApiResponse<IUser>> {
    return this.http.put<IApiResponse<IUser>>(`${this.apiUrl}/users`, user);
  }

  getUsersByRole(
    roleId: number,
    search?: string,
    pageNumber?: number,
    pageSize?: number,
    countryId?: number,
  ): Observable<IApiResponse<IUser[]>> {
    const params: Record<string, string> = {};

    if (search?.trim()) {
      params['search'] = search;
    }

    if (pageNumber !== undefined) {
      params['pageNumber'] = pageNumber.toString();
    }

    if (pageSize !== undefined) {
      params['pageSize'] = pageSize.toString();
    }

    if (countryId !== undefined) {
      params['countryId'] = countryId.toString();
    }

    return this.http.get<IApiResponse<IUser[]>>(`${this.apiUrl}/users/role/${roleId}`, {
      params,
    });
  }

  deleteUser(id: number): Observable<IDeleteResponse> {
    return this.http.delete<IDeleteResponse>(`${this.apiUrl}/users/${id}`);
  }
}
